import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS, Permission } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/relations/relations/{-$relationId}/')({
  validateSearch: zodValidator(withDefaults(schema.RELATIONS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, params, preload }) => {
    const { relationId } = params;
    const path = PAGE_PATHS.RELATIONS;
    const permissionsByMode =
      relationId === 'relations'
        ? context.userPermissions.hasAllowedPermission({ path, permission: Permission.UPDATE })
        : relationId === 'new'
          ? context.userPermissions.hasAllowedPermission({ path, permission: Permission.UPDATE })
          : undefined;
    const isAllowed = context.userPermissions.hasAllowedPermission({ path }) || !!permissionsByMode;
    context.validatePermissions({ isAllowed, preload });
  },
});
